import React from "react";
import "./ItemList.css";
import TimeSlotSelector from "./TimeSlotSelector";

const ItemList = ({
  selectedSport,
  selectedBookingType,
  selectedDate,
  selectedTimeslots,
  onTimeslotSelect,
  bookedTimeslots,
}) => {
  // Exit early if sport or booking type is not selected
  if (!selectedSport || !selectedBookingType) return null;

  // Do not render anything if no date is selected
  if (!selectedDate) {
    return null;
  }

  // Since ItemList is only used for "Bookings", we only render TimeSlotSelector
  if (selectedBookingType !== "Bookings") return null;

  return (
    <div className="item-list">
      <TimeSlotSelector
        selectedTimeslots={selectedTimeslots}
        onTimeslotSelect={onTimeslotSelect}
        bookedTimeslots={bookedTimeslots}
        selectedDate={selectedDate}
      />
    </div>
  );
};

export default ItemList;